<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1"><v-icon left>mdi-account-group</v-icon>Nómina colaboradores</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  hide-details
                  item-text="ciclo"
                  return-object
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="2">
                <v-select
                  :items="semanasSelector"
                  v-model="selectedHeaders"
                  label="# Semana"
                  filled
                  dense
                  hide-details
                  item-text="bloque"
                  item-value="value"
                  :disabled="!semanasSelector.length"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="2">
                <v-select
                  :items="puestosFiltro"
                  v-model="filtroPuesto"
                  label="Puesto"
                  filled
                  dense
                  hide-details
                  clearable
                  :disabled="!nominaActual.length"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  v-model="search"
                  label="Buscar colaborador"
                  filled
                  dense
                  hide-details
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="2" class="d-flex align-center">
                <v-btn
                  color="primary"
                  small
                  tile
                  :loading="cargar"
                  :disabled="!ciclo || !selectedHeaders"
                  @click="initialize"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mt-3" dense>
              <v-col cols="12" sm="6" md="3">
                <v-sheet class="pa-3 resumen-card" color="grey lighten-4" rounded>
                  <div class="text-caption grey--text text--darken-1">{{ modoVista === 'director' ? 'Alcance' : 'Departamento' }}</div>
                  <div class="text-subtitle-1 font-weight-bold black--text">
                    {{ modoVista === 'director' ? 'Jefes de departamento' : (departamento || '—') }}
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-sheet class="pa-3 resumen-card" color="blue lighten-5" rounded>
                  <div class="text-caption grey--text text--darken-1">Colaboradores</div>
                  <div class="text-h6 font-weight-bold blue--text text--darken-2">{{ resumenVista.total_colaboradores }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-sheet class="pa-3 resumen-card" color="green lighten-5" rounded>
                  <div class="text-caption grey--text text--darken-1">Total nómina semanal</div>
                  <div class="text-h6 font-weight-bold green--text text--darken-2">{{ formatMoney(resumenVista.suma_monto_total) }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-sheet class="pa-3 resumen-card" color="indigo lighten-5" rounded>
                  <div class="text-caption grey--text text--darken-1">Sueldo contratado semanal</div>
                  <div class="text-h6 font-weight-bold indigo--text text--darken-2">{{ formatMoney(resumenVista.suma_sueldo_contratado_semanal) }}</div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row class="mt-1" dense>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Mensual contratado</div>
                  <div class="font-weight-bold">{{ formatMoney(resumenVista.suma_sueldo_contratado_mensual) }}</div>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Laborado</div>
                  <div class="font-weight-bold">{{ formatMoney(resumenVista.suma_monto_laborado) }}</div>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Horas extras</div>
                  <div class="font-weight-bold">{{ formatMoney(resumenVista.suma_monto_horas_extras) }}</div>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Comisiones</div>
                  <div class="font-weight-bold">{{ formatMoney(resumenVista.suma_monto_comisiones) }}</div>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Rebajes</div>
                  <div class="font-weight-bold error--text">{{ formatMoney(resumenVista.suma_monto_rebajes) }}</div>
                </div>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="totales-mini pa-2">
                  <div class="text-caption">Bonos</div>
                  <div class="font-weight-bold success--text">{{ formatMoney(resumenVista.suma_monto_bonos) }}</div>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="nominaFiltrada"
              :search="search"
              class="elevation-0 mt-3"
              dense
              item-key="id"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
              :loading="cargar"
              :mobile-breakpoint="100"
            >
              <template v-slot:item.sueldo_contratado_mensual="{ item }">
                <span class="text-no-wrap">{{ formatMoney(item.sueldo_contratado_mensual) }}</span>
              </template>

              <template v-slot:item.sueldo_contratado_semanal="{ item }">
                <span class="text-no-wrap">{{ formatMoney(item.sueldo_contratado_semanal) }}</span>
              </template>

              <template v-slot:item.monto_laborado="{ item }">
                <span class="d-inline-flex align-center text-no-wrap">
                  {{ formatMoney(item.monto_laborado) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleMontoLaborado(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.monto_horas_extras="{ item }">
                <span class="d-inline-flex align-center text-no-wrap">
                  {{ formatMoney(item.monto_horas_extras) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleHorasExtras(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.comisiones_semana="{ item }">
                <span class="d-inline-flex align-center text-no-wrap">
                  {{ formatMoney(item.comisiones_semana) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleComisiones(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.monto_total_rebajes="{ item }">
                <span class="d-inline-flex align-center text-no-wrap">
                  {{ formatMoney(item.monto_total_rebajes) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleRebajes(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.monto_total_bonos="{ item }">
                <span class="d-inline-flex align-center text-no-wrap">
                  {{ formatMoney(item.monto_total_bonos) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleBonos(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.monto_total="{ item }">
                <span class="d-inline-flex align-center text-no-wrap font-weight-medium">
                  {{ formatMoney(item.monto_total) }}
                  <v-icon
                    small
                    class="ml-1 info-monto"
                    color="primary"
                    title="Ver detalle"
                    @click.stop="abrirDetalleMontoTotal(item)"
                  >mdi-information-outline</v-icon>
                </span>
              </template>

              <template v-slot:item.estatus_nomina="{ item }">
                <v-chip v-if="item.estatus_nomina == 1" x-small color="success" dark>Aceptada</v-chip>
                <v-chip v-else-if="item.estatus_nomina == 2" x-small color="error" dark>Rechazada</v-chip>
                <v-chip v-else x-small outlined>Pendiente</v-chip>
              </template>

              <template v-slot:no-data>
                <div class="pa-4 text-center black--text">
                  <div v-if="!ciclo || !selectedHeaders">Selecciona ciclo y semana para consultar la nómina.</div>
                  <div v-else>No hay colaboradores para el departamento en esta semana.</div>
                  <v-btn
                    v-if="ciclo && selectedHeaders"
                    color="primary"
                    class="mt-3"
                    small
                    @click="initialize"
                  >
                    Actualizar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Detalle jornada laboral -->
    <v-dialog v-model="dialogMontoLaborado" hide-overlay persistent max-width="560">
      <v-card>
        <v-card-title class="text-h6">
          Desglose Monto Jornada Laboral
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">{{ colaboradorDetalle }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="formula_monto_laborado"
            rows="3"
            auto-grow
            label="Sueldo Diario  X  Cantidad Dias Laborados"
            filled
            hide-details
            readonly
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogMontoLaborado = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle horas extras -->
    <v-dialog v-model="dialogHorasExtras" hide-overlay persistent max-width="500">
      <v-card>
        <v-card-title class="text-h6">
          Desglose Monto Horas Extras
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">{{ colaboradorDetalle }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="formula_horas_extras"
            rows="3"
            auto-grow
            label="Sueldo Hora  X  Cantidad Horas Extras"
            filled
            hide-details
            readonly
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogHorasExtras = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle comisiones -->
    <v-dialog v-model="dialogComisiones" hide-overlay persistent max-width="480">
      <v-card>
        <v-card-title class="text-h6">
          Monto Comisiones
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">{{ colaboradorDetalle }}</span>
        </v-card-title>
        <v-card-text>
          <div class="text-subtitle-1 black--text">
            Total comisiones de la semana: <b>{{ montoComisionesDetalle || '$0.00' }}</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogComisiones = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle rebajes -->
    <v-dialog v-model="dialogMontoRebajes" hide-overlay persistent max-width="520">
      <v-card>
        <v-card-title class="text-h6 py-3">
          <v-icon left color="primary">mdi-cash-minus</v-icon>
          Desglose Monto Rebajes
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">{{ colaboradorDetalle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-list dense class="py-0">
            <div v-for="(concepto, i) in rebajesDetalleItems" :key="'c-' + i">
              <v-list-item class="px-0" :class="{ 'align-start': (concepto.subItems && concepto.subItems.length) || (concepto.detalleItems && concepto.detalleItems.length) }">
                <v-list-item-icon class="mr-3 mt-1">
                  <v-icon :color="concepto.iconColor" small>{{ concepto.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <div class="d-flex align-center">
                    <v-list-item-title class="text-body-2 font-weight-medium">{{ concepto.label }}</v-list-item-title>
                    <v-btn
                      v-if="(concepto.detalleItems && concepto.detalleItems.length) || (concepto.subItems && concepto.subItems.length)"
                      x-small
                      text
                      class="ml-2"
                      @click="toggleRebajeDetalle(concepto.id)"
                    >
                      <v-icon x-small>{{ rebajesExpandidos[concepto.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      <span class="text-caption ml-1">{{ rebajesExpandidos[concepto.id] ? 'Ocultar' : 'Ver detalle' }}</span>
                    </v-btn>
                  </div>
                  <div v-if="concepto.subItems && concepto.subItems.length && rebajesExpandidos[concepto.id]" class="ml-2 mt-2">
                    <div v-for="(sub, j) in concepto.subItems" :key="j" class="d-flex align-center text-caption mb-1 grey--text text--darken-1">
                      <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                      <span>{{ sub.fecha }}: {{ sub.entrada }}</span>
                    </div>
                  </div>
                  <div v-if="concepto.detalleItems && concepto.detalleItems.length && rebajesExpandidos[concepto.id]" class="ml-2 mt-2">
                    <div v-for="(d, j) in concepto.detalleItems" :key="j" class="text-caption mb-2 pa-2 grey lighten-4 rounded">
                      <div v-if="d && typeof d === 'object'">
                        <div v-if="(d.cantidad != null && d.cantidad !== '') || (d.Cantidad != null && d.Cantidad !== '')" class="d-flex align-center mb-1">
                          <span class="font-weight-medium mr-1">Cantidad:</span>
                          <span>$ {{ formatMonto(d.cantidad || d.Cantidad) }}</span>
                        </div>
                        <div v-if="(d.comentario != null && d.comentario !== '') || (d.Comentario != null && d.Comentario !== '')" class="d-flex align-center mb-1">
                          <span class="font-weight-medium mr-1">Comentario:</span>
                          <span>{{ d.comentario || d.Comentario }}</span>
                        </div>
                      </div>
                      <div v-else>{{ d }}</div>
                    </div>
                  </div>
                </v-list-item-content>
                <v-list-item-action class="ml-2">
                  <span class="text-subtitle-2 font-weight-bold primary--text">$ {{ concepto.valor }}</span>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="i < rebajesDetalleItems.length - 1" class="my-2"></v-divider>
            </div>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogMontoRebajes = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle bonos -->
    <v-dialog v-model="dialogMontoBonos" hide-overlay persistent max-width="520">
      <v-card>
        <v-card-title class="text-h6 py-3">
          <v-icon left color="primary">mdi-cash-plus</v-icon>
          Desglose Monto Bonos
          <v-spacer></v-spacer>
          <span class="text-caption grey--text mr-2">{{ colaboradorDetalle }}</span>
          <v-btn icon small @click="dialogMontoBonos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <div class="caption grey--text text--darken-1 mb-3">
            Ventas + RI + Puntualidad + Prima Vacacional + Compensaciones
          </div>
          <v-list dense class="py-0">
            <div v-for="(concepto, i) in bonosDetalleItems" :key="'b-' + i">
              <v-list-item class="px-0">
                <v-list-item-icon class="mr-3 my-0 align-self-center">
                  <v-icon :color="concepto.iconColor" small>{{ concepto.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-medium">{{ concepto.label }}</v-list-item-title>
                  <v-list-item-subtitle v-if="concepto.hint" class="caption">{{ concepto.hint }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ml-2 my-0 align-self-center">
                  <span
                    class="text-subtitle-2 font-weight-bold"
                    :class="concepto.esTotal ? 'success--text' : 'primary--text'"
                  >
                    {{ formatMoneyBonos(concepto.valor) }}
                  </span>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="i < bonosDetalleItems.length - 1" class="my-2"></v-divider>
            </div>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogMontoBonos = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle monto total -->
    <v-dialog v-model="dialogMontoTotal" hide-overlay persistent max-width="520">
      <v-card>
        <v-card-title class="text-h6">
          Desglose Monto Total
          <v-spacer></v-spacer>
          <span class="text-caption grey--text">{{ colaboradorDetalle }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="formula_monto_total"
            rows="3"
            auto-grow
            label="(Jornada + Compensaciones + Horas Extras + Comisiones + Bonos) - Rebajes"
            filled
            hide-details
            readonly
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile dark small @click="dialogMontoTotal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  components: {
    Alerta,
    carga,
  },

  mixins: [validarErrores],

  data: () => ({
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    respuestaAlerta: false,
    cargar: false,
    fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    ciclos: [],
    ciclo: null,
    selectedHeaders: null,
    semanasCiclo: [],
    _configurandoFiltros: false,
    nominaActual: [],
    departamento: '',
    modoVista: 'departamento',
    resumen: {},
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: '',
    filtroPuesto: null,
    colaboradorDetalle: '',
    dialogMontoLaborado: false,
    dialogHorasExtras: false,
    dialogComisiones: false,
    dialogMontoRebajes: false,
    dialogMontoBonos: false,
    dialogMontoTotal: false,
    formula_monto_laborado: '',
    formula_horas_extras: '',
    formula_monto_total: '',
    montoComisionesDetalle: '$0.00',
    rebajesDetalleItems: [],
    rebajesExpandidos: {},
    bonosDetalleItems: [],
    headers: [
      { text: 'Empleado', value: 'nombre_completo' },
      { text: 'Puesto', value: 'puesto' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Sueldo contratado mensual', value: 'sueldo_contratado_mensual', align: 'end' },
      { text: 'Sueldo contratado semanal', value: 'sueldo_contratado_semanal', align: 'end' },
      { text: 'Monto Jornada Laboral', value: 'monto_laborado', align: 'end' },
      { text: 'Monto Horas Extras', value: 'monto_horas_extras', align: 'end' },
      { text: 'Monto Comisiones', value: 'comisiones_semana', align: 'end' },
      { text: 'Monto Rebajes', value: 'monto_total_rebajes', align: 'end' },
      { text: 'Monto Bonos', value: 'monto_total_bonos', align: 'end' },
      { text: 'Monto Total', value: 'monto_total', align: 'end' },
      { text: 'Estatus', value: 'estatus_nomina', align: 'center' },
    ],
  }),

  computed: {
    semanasSelector() {
      return this.semanasCiclo || []
    },

    puestosFiltro() {
      const puestos = {}
      ;(this.nominaActual || []).forEach((el) => {
        const puesto = el && el.puesto ? String(el.puesto).trim() : ''
        if (puesto) puestos[puesto] = true
      })
      return Object.keys(puestos).sort((a, b) => a.localeCompare(b, 'es'))
    },

    nominaFiltrada() {
      if (!this.filtroPuesto) return this.nominaActual || []
      return (this.nominaActual || []).filter((el) => el.puesto === this.filtroPuesto)
    },

    resumenVista() {
      return this.calcularResumen(this.nominaFiltrada)
    },
  },

  watch: {
    ciclo(value, oldValue) {
      if (!value || this._configurandoFiltros) return
      if (!oldValue || oldValue.id_ciclo !== value.id_ciclo) {
        this.actualizarSemanas()
      }
    },

    selectedHeaders(value) {
      if (this._configurandoFiltros || !value) return
      this.initialize()
    },

    filtroPuesto() {
      this.page = 1
    },
  },

  async created() {
    await this.cargarCiclos()
  },

  methods: {
    setColaboradorDetalle(item) {
      this.colaboradorDetalle = item && item.nombre_completo ? item.nombre_completo : ''
    },

    abrirDetalleMontoLaborado(item) {
      this.setColaboradorDetalle(item)
      this.formulaMontoLaborado(item)
      this.dialogMontoLaborado = true
    },

    abrirDetalleHorasExtras(item) {
      this.setColaboradorDetalle(item)
      this.formulaMontoHorasExtras(item)
      this.dialogHorasExtras = true
    },

    abrirDetalleComisiones(item) {
      this.setColaboradorDetalle(item)
      this.montoComisionesDetalle = this.formatMoney(item && item.comisiones_semana)
      this.dialogComisiones = true
    },

    abrirDetalleRebajes(item) {
      this.setColaboradorDetalle(item)
      this.formulaMontoRebajes(item)
      this.dialogMontoRebajes = true
    },

    abrirDetalleBonos(item) {
      this.setColaboradorDetalle(item)
      this.formulaMontoBonos(item)
      this.dialogMontoBonos = true
    },

    abrirDetalleMontoTotal(item) {
      this.setColaboradorDetalle(item)
      this.formulaMontoTotal(item)
      this.dialogMontoTotal = true
    },

    parseMontoBonos(val) {
      if (val == null || val === '') return 0
      const n = parseFloat(String(val).replace(/[$,]/g, ''))
      return Number.isFinite(n) ? n : 0
    },

    formatMonto(val) {
      const n = this.parseMontoBonos(val)
      return n.toFixed(2)
    },

    formatMoney(val) {
      const n = this.parseMontoBonos(val)
      return n.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    formatMoneyBonos(val) {
      return this.formatMoney(val)
    },

    calcularResumen(rows) {
      const lista = rows || []
      const resumen = {
        total_colaboradores: lista.length,
        suma_sueldo_contratado_mensual: 0,
        suma_sueldo_contratado_semanal: 0,
        suma_monto_laborado: 0,
        suma_monto_horas_extras: 0,
        suma_monto_comisiones: 0,
        suma_monto_rebajes: 0,
        suma_monto_bonos: 0,
        suma_monto_total: 0,
      }

      for (let i = 0; i < lista.length; i++) {
        const row = lista[i]
        resumen.suma_sueldo_contratado_mensual += this.parseMontoBonos(
          row.sueldo_contratado_mensual_num != null ? row.sueldo_contratado_mensual_num : row.sueldo_contratado_mensual
        )
        resumen.suma_sueldo_contratado_semanal += this.parseMontoBonos(
          row.sueldo_contratado_semanal_num != null ? row.sueldo_contratado_semanal_num : row.sueldo_contratado_semanal
        )
        resumen.suma_monto_laborado += this.parseMontoBonos(row.monto_laborado)
        resumen.suma_monto_horas_extras += this.parseMontoBonos(row.monto_horas_extras)
        resumen.suma_monto_comisiones += this.parseMontoBonos(row.comisiones_semana)
        resumen.suma_monto_rebajes += this.parseMontoBonos(row.monto_total_rebajes)
        resumen.suma_monto_bonos += this.parseMontoBonos(row.monto_total_bonos)
        resumen.suma_monto_total += this.parseMontoBonos(row.monto_total)
      }

      return resumen
    },

    formatFecha(fechadata) {
      if (!fechadata) return '-'
      const fechaString = String(fechadata).substr(0, 10)
      const parts = fechaString.split('-').map(Number)
      if (parts.length < 3) return fechaString
      const year = parts[0]
      const month = parts[1]
      const day = parts[2]
      const fecha = new Date(year, month - 1, day)
      const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
      const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      return diasSemana[fecha.getDay()] + ' ' + day + ' de ' + meses[month - 1]
    },

    formulaMontoLaborado(item) {
      if (!item) {
        this.formula_monto_laborado = ''
        return
      }

      const diasNoCompletos = Array.isArray(item.dias_no_completos) ? item.dias_no_completos : []
      const lunes = diasNoCompletos.includes('Monday')
      const martes = diasNoCompletos.includes('Tuesday')
      const miercoles = diasNoCompletos.includes('Wednesday')
      const jueves = diasNoCompletos.includes('Thursday')
      const viernes = diasNoCompletos.includes('Friday')
      const sabado = diasNoCompletos.includes('Saturday')
      const domingo = diasNoCompletos.includes('Sunday')

      const sueldo_dia = item.sueldo_dia
      const dia_laboral = item.dia_laboral

      this.formula_monto_laborado = `$${sueldo_dia}  X  ${dia_laboral} dias\n
Días laborados:\n
Sábado: 
${ item.dia_descanso == 1 ? 'Descanso' : !item.entrada1 ? 'Sin registro' : item.entrada1 + ' a ' + item.salida1 } 
${ item.entrada1 && item.salida1 ? (item.estatus1 == 0 ? 'JORNADA COMPLETA' : item.estatus1 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus1 == 2 ? '' : sabado ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Domingo: 
${ item.dia_descanso == 2 ? 'Descanso' : !item.entrada2 ? 'Sin registro' : item.entrada2 + ' a ' + item.salida2 } 
${ item.entrada2 && item.salida2 ? (item.estatus2 == 0 ? 'JORNADA COMPLETA' : item.estatus2 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus2 == 2 ? '' : domingo ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Lunes: 
${ item.dia_descanso == 3 ? 'Descanso' : !item.entrada3 ? 'Sin registro' : item.entrada3 + ' a ' + item.salida3 } 
${ item.entrada3 && item.salida3 ? (item.estatus3 == 0 ? 'JORNADA COMPLETA' : item.estatus3 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus3 == 2 ? '' : lunes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Martes: 
${ item.dia_descanso == 4 ? 'Descanso' : !item.entrada4 ? 'Sin registro' : item.entrada4 + ' a ' + item.salida4 } 
${ item.entrada4 && item.salida4 ? (item.estatus4 == 0 ? 'JORNADA COMPLETA' : item.estatus4 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus4 == 2 ? '' : martes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Miércoles: 
${ item.dia_descanso == 5 ? 'Descanso' : !item.entrada5 ? 'Sin registro' : item.entrada5 + ' a ' + item.salida5 } 
${ item.entrada5 && item.salida5 ? (item.estatus5 == 0 ? 'JORNADA COMPLETA' : item.estatus5 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus5 == 2 ? '' : miercoles ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Jueves: 
${ item.dia_descanso == 6 ? 'Descanso' : !item.entrada6 ? 'Sin registro' : item.entrada6 + ' a ' + item.salida6 } 
${ item.entrada6 && item.salida6 ? (item.estatus6 == 0 ? 'JORNADA COMPLETA' : item.estatus6 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus6 == 2 ? '' : jueves ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n
Viernes: 
${ item.dia_descanso == 7 ? 'Descanso' : !item.entrada7 ? 'Sin registro' : item.entrada7 + ' a ' + item.salida7 } 
${ item.entrada7 && item.salida7 ? (item.estatus7 == 0 ? 'JORNADA COMPLETA' : item.estatus7 == 1 ? 'JORNADA CON RETARDO' : 'DESCANSO') : item.estatus7 == 2 ? '' : viernes ? 'SALIDA ANTICIPADA' : 'ERROR EN LA JORNADA' }\n`
    },

    formulaMontoHorasExtras(item) {
      if (!item) {
        this.formula_horas_extras = ''
        return
      }
      const sueldo_hora = item.sueldo_hora
      const cantidad_horas = item.cantidad_horas
      this.formula_horas_extras = `${sueldo_hora}  X  ${cantidad_horas ? cantidad_horas : 0} horas extras`
    },

    formulaMontoRebajes(item) {
      if (!item) {
        this.rebajesDetalleItems = []
        return
      }

      const rebajes = item.rebajes != null ? item.rebajes : 0.00
      const seguroIMSS = item.seguroIMSS != null ? item.seguroIMSS : 0.00
      const cajaAhorro = item.cajaAhorro != null ? item.cajaAhorro : 0.00
      const monto_retardo = item.monto_retardo != null ? item.monto_retardo : 0.00
      const retensiones = item.retensiones != null ? item.retensiones : 0.00
      const devoluciones = item.devoluciones != null ? item.devoluciones : 0.00

      const subItems = []
      if (monto_retardo && item.fechas) {
        if (item.estatus1 == 1 && item.fechas[0]) subItems.push({ fecha: this.formatFecha(item.fechas[0]), entrada: item.entrada1 || '-' })
        if (item.estatus2 == 1 && item.fechas[1]) subItems.push({ fecha: this.formatFecha(item.fechas[1]), entrada: item.entrada2 || '-' })
        if (item.estatus3 == 1 && item.fechas[2]) subItems.push({ fecha: this.formatFecha(item.fechas[2]), entrada: item.entrada3 || '-' })
        if (item.estatus4 == 1 && item.fechas[3]) subItems.push({ fecha: this.formatFecha(item.fechas[3]), entrada: item.entrada4 || '-' })
        if (item.estatus5 == 1 && item.fechas[4]) subItems.push({ fecha: this.formatFecha(item.fechas[4]), entrada: item.entrada5 || '-' })
        if (item.estatus6 == 1 && item.fechas[5]) subItems.push({ fecha: this.formatFecha(item.fechas[5]), entrada: item.entrada6 || '-' })
        if (item.estatus7 == 1 && item.fechas[6]) subItems.push({ fecha: this.formatFecha(item.fechas[6]), entrada: item.entrada7 || '-' })
      }

      const rebajesDetalle = item.rebajes_detalle && Array.isArray(item.rebajes_detalle)
        ? item.rebajes_detalle
        : (item.rebajes_detalle ? [item.rebajes_detalle] : [])

      this.rebajesDetalleItems = [
        { id: 'retardo', label: 'Monto Retardo', valor: this.formatMonto(monto_retardo), icon: 'mdi-clock-alert-outline', iconColor: 'orange', subItems: subItems },
        { id: 'rebajes', label: 'Monto Otros (Rebajes)', valor: this.formatMonto(rebajes), icon: 'mdi-cash-minus', iconColor: 'grey darken-2', detalleItems: rebajesDetalle },
        { id: 'imss', label: 'Seguro IMSS', valor: this.formatMonto(seguroIMSS), icon: 'mdi-shield-account', iconColor: 'blue' },
        { id: 'devoluciones', label: 'Devoluciones', valor: this.formatMonto(devoluciones), icon: 'mdi-cash-refund', iconColor: 'red' },
        { id: 'caja', label: 'Caja de Ahorro', valor: this.formatMonto(cajaAhorro), icon: 'mdi-piggy-bank-outline', iconColor: 'green' },
        { id: 'retenciones', label: 'Retenciones', valor: this.formatMonto(retensiones), icon: 'mdi-bank-transfer-out', iconColor: 'purple' },
      ]
      this.rebajesExpandidos = {}
    },

    toggleRebajeDetalle(id) {
      this.$set(this.rebajesExpandidos, id, !this.rebajesExpandidos[id])
    },

    formulaMontoBonos(item) {
      if (!item) {
        this.bonosDetalleItems = []
        return
      }

      const ventas = this.parseMontoBonos(item.bonos_ventas)
      const ri = this.parseMontoBonos(item.bonos_ri)
      const puntualidad = this.parseMontoBonos(item.bonos_puntualidad)
      const prima = this.parseMontoBonos(item.prima_vacacional)
      const compensaciones = this.parseMontoBonos(item.compensaciones)
      const totalCalc = ventas + ri + puntualidad + prima + compensaciones
      const totalCampo = this.parseMontoBonos(item.monto_total_bonos)
      const total = totalCampo > 0 ? totalCampo : totalCalc

      this.bonosDetalleItems = [
        { label: 'Bonos Ventas', hint: 'Mejor vendedora / NI', valor: ventas, icon: 'mdi-trophy-outline', iconColor: 'amber darken-2' },
        { label: 'Bonos RI', hint: 'Reinscripciones', valor: ri, icon: 'mdi-account-multiple-plus-outline', iconColor: 'blue darken-1' },
        { label: 'Bonos Puntualidad', hint: 'PYA', valor: puntualidad, icon: 'mdi-clock-check-outline', iconColor: 'teal darken-1' },
        { label: 'Prima Vacacional', hint: 'Vacaciones aceptadas (jefe + RH)', valor: prima, icon: 'mdi-beach', iconColor: 'green darken-1' },
        { label: 'Compensaciones', hint: 'Otros bonos / compensaciones', valor: compensaciones, icon: 'mdi-cash-plus', iconColor: 'indigo darken-1' },
        { label: 'Total bonos', hint: '', valor: total, icon: 'mdi-sigma', iconColor: 'success', esTotal: true },
      ]
    },

    formulaMontoTotal(item) {
      if (!item) {
        this.formula_monto_total = ''
        return
      }

      const monto_laborado = item.monto_laborado != null ? item.monto_laborado : 0.00
      const compensaciones = item.compensaciones != null ? item.compensaciones : 0.00
      const monto_horas_extras = item.monto_horas_extras != null ? item.monto_horas_extras : 0.00
      const comisiones_semana = item.comisiones_semana != null ? item.comisiones_semana : 0.00
      const monto_total_rebajes = item.monto_total_rebajes != null ? item.monto_total_rebajes : 0.00
      const monto_total_bonos = item.monto_total_bonos != null ? item.monto_total_bonos : 0.00
      const monto_total = item.monto_total != null ? item.monto_total : 0.00

      this.formula_monto_total = `
Monto Jornada Laboral: ${monto_laborado}
Monto Compensaciones: ${compensaciones}
Monto Horas Extras: ${monto_horas_extras}
Monto Comisiones: ${comisiones_semana}
Monto Bonos: ${monto_total_bonos}
Monto Rebajes: ${monto_total_rebajes}
Total a pagar: ${monto_total}
`
    },

    calcularSemanasCiclo(ciclo) {
      if (!ciclo || !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo) return []

      const parseDate = (fecha) => new Date(fecha.substr(0, 10) + 'T12:00:00')
      const formatDate = (fecha) => fecha.toISOString().substr(0, 10)
      const inicio = parseDate(ciclo.fecha_inicio_ciclo)
      const fin = parseDate(ciclo.fecha_fin_ciclo)
      const semanas = []
      let current = new Date(inicio)
      let num = 1

      while (current <= fin) {
        const weekStart = new Date(current)
        const weekEnd = new Date(current)
        weekEnd.setDate(weekEnd.getDate() + 6)
        if (weekEnd > fin) weekEnd.setTime(fin.getTime())

        semanas.push({
          bloque: 'Semana ' + num,
          value: num,
          fecha_inicio: formatDate(weekStart),
          fecha_fin: formatDate(weekEnd),
        })

        num++
        current.setDate(current.getDate() + 7)
      }

      return semanas
    },

    actualizarSemanas() {
      this.semanasCiclo = this.calcularSemanasCiclo(this.ciclo)

      if (!this.semanasCiclo.length) {
        this.selectedHeaders = null
        this.nominaActual = []
        return
      }

      const semanaActual = this.semanasCiclo.find(
        (el) => this.fecha >= el.fecha_inicio && this.fecha <= el.fecha_fin
      )

      this.selectedHeaders = semanaActual
        ? semanaActual.value
        : this.semanasCiclo[this.semanasCiclo.length - 1].value
    },

    async cargarCiclos() {
      this._configurandoFiltros = true
      this.cargar = true
      this.ciclos = []

      try {
        const response = await this.$http.post('roles.get.ciclos.minomina', { fecha: this.fecha })
        this.ciclos = response.data.ciclos || []

        const cicloActual = response.data.ciclo_actual
        if (cicloActual) {
          this.ciclo = this.ciclos.find((el) => el.id_ciclo === cicloActual.id_ciclo) || cicloActual
        } else if (this.ciclos.length) {
          this.ciclo = this.ciclos[0]
        }

        if (this.ciclo) {
          this.actualizarSemanas()
        }
      } catch (error) {
        let msg = 'Error al cargar ciclos'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      } finally {
        this._configurandoFiltros = false
        this.cargar = false
        if (this.ciclo && this.selectedHeaders) {
          this.initialize()
        }
      }
    },

    getFechaConsulta() {
      if (!this.ciclo || !this.semanasCiclo.length || !this.selectedHeaders) return this.fecha
      const semana = this.semanasCiclo.find((el) => Number(el.value) === Number(this.selectedHeaders))
      return semana ? semana.fecha_fin : this.fecha
    },

    async initialize() {
      if (!this.ciclo || !this.selectedHeaders || this._configurandoFiltros) return

      this.cargar = true
      try {
        const payload = {
          fecha: this.getFechaConsulta(),
          id_ciclo: this.ciclo.id_ciclo,
          semana: this.selectedHeaders,
        }

        const response = await this.$http.post('usuarios.entradas.colaboradores', payload)
        this.nominaActual = response.data.result3 || []
        this.departamento = response.data.departamento || ''
        this.modoVista = response.data.modo || 'departamento'
        this.resumen = response.data.resumen || {}
        this.filtroPuesto = null
        this.page = 1
      } catch (error) {
        this.nominaActual = []
        this.departamento = ''
        this.modoVista = 'departamento'
        this.resumen = {}
        this.filtroPuesto = null
        let msg = 'Error al consultar nómina de colaboradores'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      } finally {
        this.cargar = false
      }
    },
  },
}
</script>

<style scoped>
.resumen-card {
  min-height: 72px;
}
.totales-mini {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
  min-height: 56px;
}
.info-monto {
  cursor: pointer;
}
</style>
